import { Injectable } from '@angular/core';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeepsPathLocationStrategy } from '../services';
import { ApplicationsApi } from '../my-account-sdk';
import { redirectToLogin } from '../shared';
import { LazyRolesChecker } from './lazy-roles-checker/lazy-roles-checker.service';
import { lastValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    public override router: Router,
    protected override keycloakAngular: KeycloakService,
    private applicationsApi: ApplicationsApi,
    private locationStrategy: KeepsPathLocationStrategy,
    private lazyRolesChecker: LazyRolesChecker,
  ) {
    super(router, keycloakAngular);
  }

  public async isAccessAllowed(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (!this.userAuthenticated) {
      await redirectToLogin(this.locationStrategy.getHashFromUrl(), this.applicationsApi, this.keycloakAngular);
      return false;
    }

    const requiredRoles: string[] = route.data['roles'];
    if (!requiredRoles?.length) {
      return true;
    }

    return await lastValueFrom(
      this.lazyRolesChecker.lazyCheckRoles(...requiredRoles).pipe(
        map((authorized) => {
          if (!authorized) {
            return this.router.parseUrl('/');
          }
          return true;
        }),
      ),
    );
  }

  get userAuthenticated() {
    return this.authenticated;
  }
}
